import normalizeSpeechPhrases from '@UI/Pages/Administration/AiEngines/Sidebars/ModelSidebar/Helpers/normalizeSpeechPhrases';
import {
	AZURE_SPEECH_FAMILY,
	SPEECH_PHRASES_MAX_COUNT,
} from '@UI/Pages/Administration/AiEngines/azureSpeechValues';

/** The minimal shape this constraint reads. */
type SpeechShape = {
	readonly family: string | null;
	readonly hasAzureSpeechSettings: boolean;
};

/** Active only when the Azure Speech settings section is shown: at most 2000 normalized phrases. */
function isSpeechPhrasesCountValid<T extends SpeechShape>(value: string, formData: T): boolean {
	if (formData.family !== AZURE_SPEECH_FAMILY || !formData.hasAzureSpeechSettings) {
		return true;
	}

	return normalizeSpeechPhrases(value).length <= SPEECH_PHRASES_MAX_COUNT;
}

export default isSpeechPhrasesCountValid;
